import {useState} from 'react'
import {FoldIcon, GitCommitIcon, UnfoldIcon} from '@primer/octicons-react'
import {Commits, type CommitsProps} from '@github-ui/commits/shared/Commits'
import {CommentsErrorFallback} from './CommentsErrorFallback'
import {useOverviewDeferredCommitDataPaginated} from './use-overview-commits'
import styles from './CommitDisclosure.module.css'

export function CommitDisclosure(props: Pick<CommitsProps, 'commitGroups' | 'repository'>) {
  const [expanded, setExpanded] = useState(false)
  const deferredCommitData = useOverviewDeferredCommitDataPaginated({enabled: expanded})
  const commits = props.commitGroups.flatMap(group => group.commits)
  const firstCommit = commits[0]
  if (!firstCommit) return null
  const authors = [
    ...new Set(commits.flatMap(commit => commit.authors.map(author => author.login || author.displayName))),
  ]
  const summary = `${commits.length} ${commits.length === 1 ? 'commit' : 'commits'}${authors.length > 0 ? ` by ${authors.join(', ')}` : ''}`
  const Icon = expanded ? FoldIcon : UnfoldIcon

  return (
    <details className={styles.CommitGroup} onToggle={event => setExpanded(event.currentTarget.open)}>
      <summary className={styles.Summary} aria-label={`${summary}, starting at commit ${firstCommit.oid.slice(0, 7)}`}>
        <Icon className={styles.Icon} />
        <span>{summary}</span>
      </summary>
      {expanded && (
        <>
          {deferredCommitData.error && (
            <CommentsErrorFallback heading="Unable to load commit details" icon={GitCommitIcon} />
          )}
          <Commits
            {...props}
            commitGroups={[{title: 'Commits', commits}]}
            deferredCommitData={deferredCommitData}
            showTimeline={false}
            loggingPrefix="prx_commits."
          />
        </>
      )}
    </details>
  )
}
